module.exports = __webpack_public_path__ + "static/Banner carrousel home Enero-01-9fa8a0401db628cb629ac539cdb19f0a.jpg";